// BBB code, pointing to the new registry
import config from '@plone/registry';
export default config;
